<!-- This represents the clickable options -->
<a class="c-vert-stepper__link" (click)="onClick()">
    <h5 class="c-vert-stepper__container">
        {{ stepName }}
        <div class="c-vert-stepper__step">
            <div class="c-vert-stepper__circle" [class.is-active]="isActive"></div>
        </div>
    </h5>
</a>
